const messages = {
    pt: {
        translations: {
            citacao: {
                fist: '"A',
                spanOne: 'simplicidade',
                second: 'é o mais alto grau da',
                spanTwo: 'sofisticação"'
            },
            home: {
                hi: 'Diga oi'
            },
            sobre: {
                hello: 'Olá',
                textOne: 'sou Joás Castelo e estou prestes a concluir minha graduação em Design Digital na Universidade Federal do Ceará (UFC), com foco em Front-end. Possuo habilidades em HTML, CSS, JavaScript, React e Vue.js, além de experiência em UX/UI. Estou acostumado a trabalhar em equipe e aplicar metodologias ágeis.',
                textTwo: 'Durante minha jornada acadêmica e profissional participei do Núcleo de Práticas em Informática (NPI) como UI/UX na criação da interface de um sistema de gerenciamento de estágios, usando Figma como principal ferramenta, também participei de uma bolsa de extensão como fullstack, onde usei React JS, Firebase, e a API do google Maps.',
                alt: 'jovem de óculos com parte do cabelo amarelo e camisa escura'
            },
            skills: {
                education: 'Conhecimento',
                prototype: 'Prototipação',
                uxText: 'Experiência em UI/UX designer. Criando interfaces atraentes e intuitivas para se destacar dos demais.',
                prototypeText: 'Conhecimento em protótipos de alta fidelidade, tirando a ideia do papel.',
                frontText: 'Conhecimento de desenvolvimento front-end, criando a parte visual e interativa de sites.',
                technologies: 'Tecnologias',
                HTMLText: 'Uso do Html5 para definição de informações e organização.',
                CSSText: 'Conhecimento aprofundado em CSS para melhor estilização.',
                JavascriptText: 'Uso da linguagem Java Script para aprimorar a interação.',
                tailwind: 'Conhecimento do Tailwind que oferece desenvolvimento rápido, manutenção fácil e uma alta personalização através de sua classes.',
                TypecriptText: 'Uso da linguagem TypeScript, atualmente amplamente utilizada no desenvolvimento front-end',
                reactText: 'Conhecimento aprofundado em React para melhor desempenho durante o desenvolvimento',
                vueText: 'Conhecimento básico em Vue'
            },
            diferenciais: {
                differential: 'Diferenciais',
                team: 'Time',
                dev: 'Desenvolvimento',
                internship: 'Estágio',
                teamText: 'Experiência no trabalho em equipe',
                devText: 'Projetos web desenvolvidos',
                internshipText: 'Experiência no mercado de trabalho com estágio no núcleo de práticas em informática',
                scrumText: 'Costume em utilizar metodologias ágeis',
            },
            projetos: {
                fortaleza: 'Uma bolsa de extensão onde tive a responsabilidade de migrar um app mobile para desktop. tive o pael de fullstack e trabalhei com react, firebase e a api do google maps, além de criar a interface. Esse projeto tem como objetivo marcar e trazer informações de músicas que citam lugares de Fortaleza.',
                ecomerce: 'Um projeto de e-comerce completo para aprimorar meus conhecimentos em Vue3.',
                deco: 'Feito no bootcamp da deco.cx, aprendendo a criar interfaces que contam com um admin para controle das informações, e estilos. O sistema  foi feito usando preact e deno, junto com TypeScript.',
                planner: 'Sistema feito na trilha ReactJS da NLWJourney ofertada pela rocketseat. O objetivo do projeto e fazer um planejador de viagens onde pode escolher local, convidar amigos via email, marcar eventos por data e horário, e adicionar links úteis, Tudo isso ultilizando TypeScript, Tailwind, e NodeJS..',
                estagio: 'Desenvolvido durante meu estágio no (NPI), que consiste em um sistema para troca de documentos referente a estágio entre alunos e professores, como pertencente da equipe de design, ficamos responsáveis por pensar a interface do sistema com um protótipo de alta fidelidade e navegável.',
                moteis: 'Este projeto de redesign da landing page do app guia de moteis go, entre os entregáveis estão: design system, wireframe, protótipo em alta fidelidade e protótipo navegável.'
            }
        }
    },
}

export { messages }